import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["provider", "sourceType", "identifier"]
  static values = { sourceTypes: Object, identifierHints: Object }

  connect() {
    this.refreshSourceTypes()
  }

  providerChanged() {
    this.refreshSourceTypes()
  }

  sourceTypeChanged() {
    this.updateIdentifierPlaceholder()
  }

  refreshSourceTypes() {
    const provider = this.providerTarget.value
    const options = this.sourceTypesValue[provider] || []
    const currentValue = this.sourceTypeTarget.value

    this.sourceTypeTarget.innerHTML = ""

    options.forEach((value) => {
      const option = document.createElement("option")
      option.value = value
      option.textContent = this.humanize(value)
      this.sourceTypeTarget.appendChild(option)
    })

    if (options.includes(currentValue)) {
      this.sourceTypeTarget.value = currentValue
    } else if (options.length > 0) {
      this.sourceTypeTarget.value = options[0]
    }

    this.updateIdentifierPlaceholder()
  }

  humanize(value) {
    return value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
  }

  updateIdentifierPlaceholder() {
    if (!this.hasIdentifierTarget) return

    const provider = this.providerTarget.value
    const sourceType = this.sourceTypeTarget.value
    const hint = this.identifierHintsValue?.[provider]?.[sourceType]
    this.identifierTarget.placeholder = hint || "Enter identifier"
  }
}
